import { TemplateFacade } from '@goparrot/campaign-sdk';
import { getConfig, getInterceptors } from '@goparrot-dashboard-api/shared';

import { CAMPAIGN_API_PATH } from '../utils/constants';

// @ts-ignore: todo
export const campaignTemplateFacade = new TemplateFacade(getConfig(CAMPAIGN_API_PATH), getInterceptors());

export const getTemplateList = async (merchantId: string) => campaignTemplateFacade.getList(merchantId);
